import { zergApi } from "@/service/zerg";

const prefix = `/rrhh/bonos`;

class BonosService {
    async index(params) {
        try {
            const data = await zergApi.get(`${prefix}/index`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getPeriodos(params) {
        try {
            const data = await zergApi.post(`${prefix}/get-periodos`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async generar(data) {
        try {
            const response = await zergApi.post(`${prefix}/generar`, data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    async recalcular(data) {
        try {
            const response = await zergApi.post(`${prefix}/recalcular`, data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getErrorMessages(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-error-messages`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getBono(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-bono`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async addDiscountToBono(params) {
        try {
            const data = await zergApi.post(`${prefix}/add-discount-to-bono`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }


    async aprobarBono(params) {
        try {
            const data = await zergApi.post(`${prefix}/aprobar-bono`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async consultarBono(batchId) {
        try {
            const { data } = await zergApi.get(`${prefix}/consultar-bono/${batchId}`);
            return data;
        } catch (error) {
            throw error;
        }
    }


    /***** A D I C I O N A L E S      P A R A      A U M E N T A R     B O N O *********** */
    async getAdicionalBono(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-adicional-bono`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async registrarAdicionalBono(params) {
        try {
            const response = await zergApi.post(`${prefix}/registrar-adicional-bono`, params);
            return response;
        } catch (error) {
            throw error;
        }
    }

    async actualizarAdicionalBono(params) {
        try {
            const response = await zergApi.post(`${prefix}/actualizar-adicional-bono`, params);
            return response;
        } catch (error) {
            throw error;
        }
    }


    async eliminarAdicionalBono(params) {
        try {
            const response = await zergApi.post(`${prefix}/eliminar-adicional-bono`, params);
            return response;
        } catch (error) {
            throw error;
        }
    }

    async generarPdfBono(params) {
        try {
            const data = await zergApi.post(`${prefix}/generar-pdf-bono`, params, { responseType: "blob" });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getResumenBono(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-resumen-bono`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    /***** A J U S T E S    D E L    B O N O    D E    R E T O R N O S    P O R    V I A J E *********** */
    async getRetornosDetalle(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-retornos-detalle`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async ajustarRetorno(params) {
        try {
            const data = await zergApi.post(`${prefix}/ajustar-retorno`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async quitarAjusteRetorno(params) {
        try {
            const data = await zergApi.post(`${prefix}/quitar-ajuste-retorno`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    /***** A J U S T E S    D E L    B O N O    T R A M O    3    ( 2 5 0 - 9 8 0 K M ) *********** */
    async getTramo3Detalle(params) {
        try {
            const data = await zergApi.get(`${prefix}/get-tramo3-detalle`, { params });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async ajustarTramo3(params) {
        try {
            const data = await zergApi.post(`${prefix}/ajustar-tramo3`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async quitarAjusteTramo3(params) {
        try {
            const data = await zergApi.post(`${prefix}/quitar-ajuste-tramo3`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new BonosService();